<template>
  <div>
    <user-roles-management-list-panel v-if='portalUserId!="user"'/>
  </div>
</template>

<script>
import UserRolesManagementListPanel  from "@/components/account/ui-components/UserRolesManagementListPanel";
import PortalAuth from '@/service/portalAuth';

export default {
    components:{
        UserRolesManagementListPanel
    },
    created: function () {
        var portalAuth = new PortalAuth();
        var loginResult =portalAuth.loginPortal()
        loginResult.then((r) => {
            console.log('login result',r);
            this.portalUserId = r.userId  
            this.$root.portalUserId = r.userId;
            window.sessionStorage.setItem('portalUserId', r.userId);
        });   
    },
    data:function(){
        return {
            portalUserId: 'user',
            showSidePanel: true
        }
    },
    methods:{
        logout: function(){
            var portalAuth = new PortalAuth();
            portalAuth.logout();
            // console.log(this);
            this.$router.push({ path: '/' })
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/account/UserManagement.vue